export const STREAMLAIN_COMPACT_HEADER_HEIGHT = 54;
export const STREAMLAIN_COMPACT_HEADER_HEIGHT_PX = `${STREAMLAIN_COMPACT_HEADER_HEIGHT}px`;
export const STREAMLAIN_COMPACT_HEADER_PADDING = '8px var(--h-padding, 16px)';
export const STREAMLAIN_COMPACT_HEADER_GAP = '8px';

export const STREAMLAIN_HEADER_BORDER_WIDTH = '0.5px';
export const STREAMLAIN_HEADER_BORDER_CENTER_OFFSET = `calc(${STREAMLAIN_HEADER_BORDER_WIDTH} / -2)`;

export const STREAMLAIN_EXPANDABLE_SECTION_HEADER_HEIGHT = 44;
export const STREAMLAIN_EXPANDABLE_SECTION_HEADER_HEIGHT_PX = `${STREAMLAIN_EXPANDABLE_SECTION_HEADER_HEIGHT}px`;

export const STREAMLAIN_COMPACT_HEADER_AREA_LIT_CSS = `
  background: var(
    --streamlain-compact-header-background,
    var(--streamlain-v2-layer-background-primary)
  );
  position: relative;
  padding: ${STREAMLAIN_COMPACT_HEADER_PADDING};
  width: 100%;
  height: ${STREAMLAIN_COMPACT_HEADER_HEIGHT_PX};
  min-height: ${STREAMLAIN_COMPACT_HEADER_HEIGHT_PX};
  max-height: ${STREAMLAIN_COMPACT_HEADER_HEIGHT_PX};
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${STREAMLAIN_COMPACT_HEADER_GAP};
  z-index: 1;
`;

export const STREAMLAIN_COMPACT_HEADER_AREA_STYLE = {
  background:
    'var(--streamlain-compact-header-background, var(--streamlain-v2-layer-background-primary))',
  position: 'relative',
  width: '100%',
  flex: `0 0 ${STREAMLAIN_COMPACT_HEADER_HEIGHT_PX}`,
  height: STREAMLAIN_COMPACT_HEADER_HEIGHT_PX,
  minHeight: STREAMLAIN_COMPACT_HEADER_HEIGHT_PX,
  maxHeight: STREAMLAIN_COMPACT_HEADER_HEIGHT_PX,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: STREAMLAIN_COMPACT_HEADER_GAP,
  zIndex: 1,
} as const;
